import { handleActions, combineActions } from 'redux-actions'
import * as formActions from '../actions'

const isAttachDetachProcessing = handleActions<number | null, any>(
  {
    [formActions.attachForm.request.toString()](state, action) {
      const typedAction = action as ReturnType<typeof formActions.attachForm.request>

      return typedAction.payload.FormId
    },
    [formActions.detachForm.request.toString()](state, action) {
      const typedAction = action as ReturnType<typeof formActions.detachForm.request>

      return typedAction.payload.formId
    },
    [combineActions(
      formActions.attachForm.success,
      formActions.attachForm.failed,
      formActions.detachForm.success,
      formActions.detachForm.failed
    ).toString()](state, action) {
      return null
    },
    [formActions.resetFormsState.toString()](state, action) {
      return null
    },
  },
  null
)

export default isAttachDetachProcessing
